// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
@keyframes waveform-module__wave-one___DFMTw {
  0% {
    height: 5px;
  }
  25% {
    height: 7px;
  }
  50% {
    height: 2px;
  }
  100% {
    height: 6px;
  }
}
@keyframes waveform-module__wave-two___t5MOU {
  0% {
    height: 3px;
  }
  25% {
    height: 9px;
  }
  50% {
    height: 5px;
  }
  100% {
    height: 7px;
  }
}
@keyframes waveform-module__wave-three___shFhL {
  0% {
    height: 2px;
  }
  25% {
    height: 7px;
  }
  50% {
    height: 3px;
  }
  100% {
    height: 5px;
  }
}
@keyframes waveform-module__wave-four___yxsiX {
  0% {
    height: 2px;
  }
  25% {
    height: 4px;
  }
  50% {
    height: 3px;
  }
  100% {
    height: 9px;
  }
}
@keyframes waveform-module__wave-five___rtvGc {
  0% {
    height: 2px;
  }
  25% {
    height: 4px;
  }
  50% {
    height: 2px;
  }
  100% {
    height: 6px;
  }
}
.waveform-module__waveform___WgRp7 {
  height: 9px;
  display: inline-block;
}
.waveform-module__waveform__line___FOdsW {
  display: inline-block;
  margin-right: 2px;
  width: 2px;
  max-height: 100%;
  background-color: var(--primary600, #4b286d);
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  animation-duration: 1s;
}
.waveform-module__waveform__line___FOdsW:nth-child(1) {
  animation-name: waveform-module__wave-one___DFMTw;
  animation-duration: 1.5s;
}
.waveform-module__waveform__line___FOdsW:nth-child(2) {
  animation-name: waveform-module__wave-two___t5MOU;
  animation-duration: 1.5s;
}
.waveform-module__waveform__line___FOdsW:nth-child(3) {
  animation-name: waveform-module__wave-three___shFhL;
  animation-duration: 1.5s;
}
.waveform-module__waveform__line___FOdsW:nth-child(4) {
  animation-name: waveform-module__wave-four___yxsiX;
  animation-duration: 1s;
}
.waveform-module__waveform__line___FOdsW:nth-child(5) {
  animation-name: waveform-module__wave-five___rtvGc;
  animation-duration: 1s;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/content/pop-out-audio/components/waveform/waveform.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE;IACE,WAAA;EAMF;EAHA;IACE,WAAA;EAKF;EAFA;IACE,WAAA;EAIF;EADA;IACE,WAAA;EAGF;AACF;AAAA;EACE;IACE,WAAA;EAEF;EACA;IACE,WAAA;EACF;EAEA;IACE,WAAA;EAAF;EAGA;IACE,WAAA;EADF;AACF;AAIA;EACE;IACE,WAAA;EAFF;EAKA;IACE,WAAA;EAHF;EAMA;IACE,WAAA;EAJF;EAOA;IACE,WAAA;EALF;AACF;AAQA;EACE;IACE,WAAA;EANF;EASA;IACE,WAAA;EAPF;EAUA;IACE,WAAA;EARF;EAWA;IACE,WAAA;EATF;AACF;AAYA;EACE;IACE,WAAA;EAVF;EAaA;IACE,WAAA;EAXF;EAcA;IACE,WAAA;EAZF;EAeA;IACE,WAAA;EAbF;AACF;AAgBA;EACE,WAAA;EACA,qBAAA;AAdF;AAgBE;EACE,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,4CAAA;EAEA,mCAAA;EACA,8BAAA;EACA,sCAAA;EACA,sBAAA;AAfJ;AAiBI;EACE,iDAAA;EACA,wBAAA;AAfN;AAiBI;EACE,iDAAA;EACA,wBAAA;AAfN;AAiBI;EACE,mDAAA;EACA,wBAAA;AAfN;AAiBI;EACE,kDAAA;EACA,sBAAA;AAfN;AAiBI;EACE,kDAAA;EACA,sBAAA;AAfN","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../../../styles/utils.scss';\n\n@keyframes wave-one {\n  0% {\n    height: 5px;\n  }\n\n  25% {\n    height: 7px;\n  }\n\n  50% {\n    height: 2px;\n  }\n\n  100% {\n    height: 6px;\n  }\n}\n\n@keyframes wave-two {\n  0% {\n    height: 3px;\n  }\n\n  25% {\n    height: 9px;\n  }\n\n  50% {\n    height: 5px;\n  }\n\n  100% {\n    height: 7px;\n  }\n}\n\n@keyframes wave-three {\n  0% {\n    height: 2px;\n  }\n\n  25% {\n    height: 7px;\n  }\n\n  50% {\n    height: 3px;\n  }\n\n  100% {\n    height: 5px;\n  }\n}\n\n@keyframes wave-four {\n  0% {\n    height: 2px;\n  }\n\n  25% {\n    height: 4px;\n  }\n\n  50% {\n    height: 3px;\n  }\n\n  100% {\n    height: 9px;\n  }\n}\n\n@keyframes wave-five {\n  0% {\n    height: 2px;\n  }\n\n  25% {\n    height: 4px;\n  }\n\n  50% {\n    height: 2px;\n  }\n\n  100% {\n    height: 6px;\n  }\n}\n\n.waveform {\n  height: 9px;\n  display: inline-block;\n\n  &__line {\n    display: inline-block;\n    margin-right: 2px;\n    width: 2px;\n    max-height: 100%;\n    background-color: color(primary600);\n\n    animation-iteration-count: infinite;\n    animation-direction: alternate;\n    animation-timing-function: ease-in-out;\n    animation-duration: 1s;\n\n    &:nth-child(1) {\n      animation-name: wave-one;\n      animation-duration: 1.5s;\n    }\n    &:nth-child(2) {\n      animation-name: wave-two;\n      animation-duration: 1.5s;\n    }\n    &:nth-child(3) {\n      animation-name: wave-three;\n      animation-duration: 1.5s;\n    }\n    &:nth-child(4) {\n      animation-name: wave-four;\n      animation-duration: 1s;\n    }\n    &:nth-child(5) {\n      animation-name: wave-five;\n      animation-duration: 1s;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"waveform": `waveform-module__waveform___WgRp7`,
	"waveform__line": `waveform-module__waveform__line___FOdsW`,
	"wave-one": `waveform-module__wave-one___DFMTw`,
	"wave-two": `waveform-module__wave-two___t5MOU`,
	"wave-three": `waveform-module__wave-three___shFhL`,
	"wave-four": `waveform-module__wave-four___yxsiX`,
	"wave-five": `waveform-module__wave-five___rtvGc`
};
export default ___CSS_LOADER_EXPORT___;
